<template>
  <LayoutLegal>
    <h2 class="mt-2">Privacy Policy</h2>

    <p>
      This Privacy Policy (the “Policy”) applies to all of the Whale Member
      (“Service Provider”) family of websites (the “Sites”), including this
      site, as well as any other Sites at which this Policy appears and which
      are owned/controlled by the Service Provider. This Policy describes how
      Service Provider uses information it obtains about its users when they
      visit one of the Sites and is inapplicable to information obtained about
      you through other channels. Please review this Policy carefully. If you
      have any questions about this Policy, please email cvv@cvvhelp.net.
    </p>
    <h3>1. Revisions.</h3>
    <p>
      Service Provider reserves the unilateral right to modify this Policy from
      time-to-time.
      <br />
      <br />
      a. By accessing, using, or joining this Site, you acknowledge that Service
      Provider possesses this unilateral right and that you will ensure that you
      stay up-to-date regarding changes to the Policy by checking it on a
      regular basis. You shall be bound by the terms of the Policy then in
      effect each time you access or use this Site.
      <br />
      b. Dates that the Policy is revised will be contained in the “Last
      Modified Date” on the top of this page. If you visit this page and see a
      new “Last Modified Date,” you agree that you shall review the Policy for
      revisions.
      <br />
      c. In the event of a conflict between this Policy and any Terms of Use for
      any Sites, this Policy shall control.
    </p>
    <h3>2. Collection of Information.</h3>
    <p>
      a. When you sign up for membership on the Site, you are required to
      provide Service Provider with your name, billing address, email address,
      postal code, bank account and routing number, telephone number, and other
      personal information. You may be asked for additional information to
      participate in special promotions, offers, contests, or polls. This is
      information Service Provider is collecting from you. Service Provider
      recognizes that, from time-to-time, the information provided during
      sign-up may become inaccurate or out-of-date. To modify the information
      provided during sign-up, please email cvv@cvvhelp.net.
      <br />
      b. In addition to collecting information if and/or when you register for
      membership, Service Provider uses cookies to collect, among other things,
      your location, your IP address, referral websites and your membership ID.
      You can turn off cookies, but you might not be able to use any or all of
      the Site, irrespective of whether you are a member.
      <br />
      c. In addition to the data that you provide to us, we may also obtain data
      from trusted third parties. This ‘profiling’ information is produced from
      a variety of sources, including publicly available data or from providers
      to whom you have given your permission for your data to be shared.
    </p>
    <h3>3. Information Collected</h3>
    <p>
      The amount of information Service Provider collects from visitors to the
      Sites largely depends upon whether the visitor is a member or is simply
      browsing the Sites. A non-member browsing one of the Sites only has the
      information collected described in Paragraph 2(b) of this Policy. Members
      to one or more of the Sites will have the information collected described
      in Paragraph 2(a) of the Policy. Service Provider may collect additional
      personal information in the event you send any communication or
      correspondence to Service Provider. Service Provider may store any and all
      information collected in its database(s).
      <br />
      <br />
      If we make other organizational services available through our Sites, you
      understand we do not operate those sites. Information as to the privacy
      practices of such other organizations is governed by their own polices and
      you should review them before providing any information to them. You
      consent that such organizations may share your personal information with
      Service Provider if you have accessed such services through our Sites.
    </p>
    <h3>4. Use of Information.</h3>
    <p>
      The primary use of information collected by Service Provider is to provide
      you access to and enhance your experience on the Sites. More specifically,
      Service Provider collects information to provide you with varying levels
      of access to one or more of the Sites and to ensure you continue to have
      access to one or more of the Sites (e.g., for monthly payment purposes).
      As stated in Paragraph 3, Service Provider also uses cookies to collect
      information to tailor the Sites to your preferences and generally to make
      your visits more enjoyable. While those are the primary reasons Service
      Provider collects information, there are others, including:
      <br />
      <br />
      <strong>a. Advertising and Marketing.</strong>
      Service Provider uses cookies and other passively collected information to
      improve its advertising and to improve the applicability of its
      advertising to your interests. Collected information may also be used for
      general market research and to track the interests of current and former
      members to one or more of the Sites. Service Provider is not responsible
      for the collection, use, or security of any information, sensitive,
      personally-identifying, or otherwise, that you voluntarily share with an
      advertiser.
      <br />
      <strong>b. Operation.</strong>
      Service Provider may share your information if it becomes necessary to
      operate one or more of the Sites properly. This may include sharing
      information with a third-party vendor to collect fees or other monies owed
      by you. Service Provider may also share your information to prevent,
      detect, or resolve issue of fraud or security.
      <br />
      <strong>c. Legal</strong>
      Service Provider may use your information for legal purposes.
      <br />
      i. For example, your information may assist Service Provider in ensuring
      that you are in compliance with the Terms of Use, including our
      intellectual property policies and the requirement that you not share your
      password with third parties. It may also be used as necessary to bring
      legal action against you in the event that you materially breach Service
      Provider’s Terms of Use.
      <br />
      ii. Service Provider may also share your information with law enforcement
      to assist in any criminal investigations against you or to comply with any
      laws or regulations.
      <br />
      iii. Service Provider may share your information with a debt collector or
      legal counsel to collect any fees or other monies owed by you or to
      otherwise enforce the Terms of Use.
      <br />
      iv. In some cases, Service Provider may be subpoenaed to provide your
      information in a civil or criminal matter. Service provider reserves the
      right to respond to a subpoena without the necessity of informing you, but
      Service Provider may provide you with an opportunity to seek to quash the
      subpoena before responding, in service provider’s sole discretion.
    </p>
    <h3>5. Data Security</h3>
    <p>
      Service Provider takes reasonable efforts to ensure that sensitive or
      personally-identifying information and data it collects remains secure. It
      uses reasonable measures any time sensitive, personal information is
      transmitted. However, nothing is perfect, and Service Provider cannot
      guarantee that hackers or other cyber-criminals will never be capable of
      infiltrating its systems. For this reason, you acknowledge and accept that
      you assume any risk that such breaches may occur despite these measures
      being in place. Non personally-identifying information may be shared
      publicly for any purpose.
    </p>
    <h3>6. Emails</h3>
    <p>
      a. Emails from Service Provider. When you sign up for one or more of the
      Sites, you provide Service Provider with an accurate email address.
      Service Provider maintains a member directory so that it may email you
      from time-to-time. These emails may concern matters Service Provider
      thinks you may find interesting, including but not limited to new Sites,
      programs, and services. Emails from Service Provider and its affiliates
      are not SPAM, as you have a business relationship with Service Provider as
      soon as you join one or more of the Sites, and you agree they should not
      otherwise be deemed as unsolicited.
      <br />
      b. Emails to Service Provider. If you contact Service Provider via email
      or via any link on one of the Sites, you should be aware that the
      information you transmit should not be considered private or secure.
      Please do not transmit any information you would not want to become
      public.
    </p>
    <h3>7. CONTACT US, QUESTIONS, UPDATING YOUR INFO, OPTING OUT</h3>
    <p>
      If you would like to update your information, please e-mail us. From time
      to time, we may email you with special offers with your consent; you may
      opt-out of those offers through the email or by contacting us as noted
      below. If you otherwise would like to contact us for a privacy-related
      matter, please use the following e-mail address: cvv@cvvhelp.net
    </p>
  </LayoutLegal>
</template>

<script setup>
  useSiteSeo({
    defaultTitle: "Privacy Policy | {{ siteName }}",
    defaultDescription:
      "This Privacy Policy (the “Policy”) applies to all of the ...",
  })
</script>
